import { useState, useEffect, useContext, useRef } from 'react';

import { inquiryHelpSearchContext } from '../InquiryHelpSearchContext';


function InquiryHelpSearchInput() {

  const {
    containerRef,
    query, setQuery,
    isDispAid, setIsDispAid,
  } = useContext(inquiryHelpSearchContext);


  // フォーカスでの入力補助表示
  const onFocus = () => {
    if (query.trim() !== '') {
      setIsDispAid(true);
    }
  }

  // 入力欄外タップで入力補助非表示
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsDispAid(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setQuery(val);
    if (val.trim() !== '') {
      setIsDispAid(true);
    } else {
      setIsDispAid(false);
    }
  };


  return (
    <div className="input-group">
      <span className="input-group-addon">
        <span className="glyphicon glyphicon-search" aria-hidden="true"></span>
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="キーワード検索"
        value={query}
        onChange={onInputChange}
        onFocus={onFocus}
      />
    </div>
  );
}
  
export default InquiryHelpSearchInput;